import React from 'react';
import {useParams,Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {getPosesByCategory,categories} from '../data/poses';

const {FiArrowLeft,FiCheckSquare,FiSquare}=FiIcons;

const categoryPalette={
  business: '#0F0F0F',
  senior: '#1C1C1C',
  couple: '#2E2A2B',
  creative: '#3B2F2F',
  lifestyle: '#4B3B3F',
  fitness: '#5C4B51',
  artistic: '#6D5C5F',
  branding: '#7E6D6F'
};

function CategoryView() {
  const {categoryId}=useParams();
  const poses=getPosesByCategory(categoryId);
  const category=categories.find(cat=> cat.id===categoryId);
  const [selectedPoses,setSelectedPoses]=React.useState(()=>{
    return JSON.parse(localStorage.getItem('selectedPoses') || '[]');
  });

  if (!category) return null;

  const togglePoseSelection=(poseId)=> {
    let newSelections=selectedPoses.includes(poseId) 
      ? selectedPoses.filter(id=> id !== poseId) 
      : [...selectedPoses, poseId];
    setSelectedPoses(newSelections);
    localStorage.setItem('selectedPoses', JSON.stringify(newSelections));
    window.dispatchEvent(new CustomEvent('favoritesUpdated'));
  };

  const getPoseNumber=(poseId)=> poseId.split('-')[1] || '1';

  return (
    <div className="max-w-6xl mx-auto">
      <header className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <Link to="/" className="inline-flex items-center text-slate-400 hover:text-brand-primary transition-colors text-[10px] uppercase tracking-[0.2em] font-bold mb-6">
            <SafeIcon icon={FiArrowLeft} className="mr-2" />
            Collection
          </Link>
          <h1 className="text-5xl md:text-7xl font-serif text-slate-900 leading-none">
            {category.name} <span className="text-slate-300 font-light">Series</span>
          </h1>
          <p className="text-slate-500 text-base mt-4 max-w-xl font-light">{category.description}</p>
        </div>
        
        <Link to="/selection" className="px-6 py-3 bg-slate-900 text-white text-[10px] uppercase tracking-widest font-bold rounded-full hover:bg-slate-800 transition-all shadow-lg hover:shadow-xl">
          View Selection ({selectedPoses.length})
        </Link>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {poses.map((pose,idx)=> (
          <motion.div key={pose.id} initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{delay: idx*0.04}} className="group relative">
            <div className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm group-hover:shadow-xl transition-all duration-500">
              <Link to={`/pose/${pose.id}`}>
                <div className="aspect-[3/4] relative overflow-hidden" style={{backgroundColor: categoryPalette[categoryId]}}>
                  <img src={pose.link} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute top-4 left-4 bg-white/20 backdrop-blur-md px-2 py-1 rounded text-[10px] text-white font-bold tracking-tighter">
                    #{getPoseNumber(pose.id)}
                  </div>
                </div>
              </Link>
              
              <div className="p-4 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Pose {getPoseNumber(pose.id)}</span>
                <button onClick={()=> togglePoseSelection(pose.id)} className="p-2 hover:bg-slate-50 rounded-full transition-colors">
                  <SafeIcon 
                    icon={selectedPoses.includes(pose.id) ? FiCheckSquare : FiSquare} 
                    className={`text-lg ${selectedPoses.includes(pose.id) ? 'text-brand-primary' : 'text-slate-200'}`} 
                  />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default CategoryView;